export default "__VITE_ASSET__CfwfW_ZT__"